const timerEls = document.querySelectorAll(".timer .timer__wrapper");

const updateTimer = (now) => {
  timerEls?.forEach((el) => {
    const startDate = el.parentElement.getAttribute("data-start-date");
    if (!startDate) return;
    const distance = new Date(startDate).getTime() - now;
    const time = {
      d: Math.floor(distance / (1000 * 60 * 60 * 24)),
      h: Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
      m: Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60)),
      s: Math.floor((distance % (1000 * 60)) / 1000),
    };

    if (el.children && distance > 0) {
      el.parentElement.classList.remove("timer--hide");
      [...el.children].forEach((childEl) => {
        const key = childEl.getAttribute("data-key");
        if (!key || !(key in time)) return;

        childEl.querySelector(".timer__value").innerHTML = time[key];
      });
    } else {
      el.parentElement.classList.add("timer--hide");
    }
  });
};
// init
updateTimer(Date.now());

setInterval(() => {
  updateTimer(Date.now());
}, 1000);
